<template>
  <section>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <PageHeader :title="headercontent.title" />
        </v-col>

        <v-col md="12">
          <v-data-table
            :items="allActivities.results"
            :headers="headers"
            :server-items-length="allActivities.pagination.total"
            :options.sync="options"
            :loading="loading"
          >
          </v-data-table>
          <div v-if="loading">
            <v-skeleton-loader type="image" height="200"></v-skeleton-loader>
            <v-skeleton-loader type="image" height="200"></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import PageHeader from "@/components/dashboard/PageHeader";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Activity",
  components: { PageHeader },
  data: () => ({
    headercontent: {
      title: "Activity List",
    },
    loading: true,
    headers: [
      { text: 'Activity Name', value: 'activityName', sortable: false },
      { text: 'Action Taken', value: 'connectedTo', sortable: false },
      { text: 'User', value: 'userHandle', sortable: false },
      { text: 'Date', value: 'createdAt', sortable: false },
    ],
    options: {
      itemsPerPage: 5,
      page: 1
    },
  }),
  computed: {
    ...mapGetters(["allActivities", "allLoadingAuth"]),
  },
  methods: {
    ...mapActions(["getActivites"]),
    async reloadActivities() {
      this.loading = true;
      await this.getActivites({
        limit: this.options.itemsPerPage,
        skip: (this.options.page - 1) * this.options.itemsPerPage,
      });
      this.loading = false;
    },
  },
  async created() {
    await this.reloadActivities();
  },
  watch: {
    options: {
      async handler() {
        await this.reloadActivities();
      },
      deep: true,
    }
  }
};
</script>
